// extracted by mini-css-extract-plugin
export default {"spacer":"t7xIqE"};